<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>出海服务</h1>
        <div class="sub">为企业出海提供一站式专业服务 · 共 {{ total }} 项</div>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="card-grid" v-if="rows.length">
          <div
            v-for="item in rows"
            :key="item.id"
            class="card service-card"
            @click="openService(item)"
          >
            <div class="service-cover">
              <img v-if="item.icon" :src="item.icon" :alt="item.title" @error="onImgError" />
              <span v-else class="cover-letter">{{ item.title.slice(0, 1) }}</span>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc">{{ item.summary }}</div>
              <div class="card-detail-btn">查看详情 ›</div>
            </div>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">暂无服务</div>
        <div class="empty-block" v-else>加载中…</div>

        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchOverseasServices } from '../api/home'

export default {
  name: 'OverseaService',
  data () {
    return {
      rows: [],
      pageNum: 1,
      pageSize: 8,
      total: 0,
      loading: true
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const res = await fetchOverseasServices({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.total = 0
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openService (item) {
      this.$router.push('/oversea-service-info/' + item.id)
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.service-cover {
  height: 170px;
  background: var(--blue-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.service-cover img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  padding: 20px;
  box-sizing: border-box;
}
.cover-letter {
  font-size: 30px;
  font-weight: 800;
  color: var(--primary);
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-main);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub);
  padding: 40px 0;
}
</style>
